import { render } from "./ViewTemplate.vue?vue&type=template&id=36b02571&scoped=true&ts=true"
import script from "./ViewTemplate.vue?vue&type=script&lang=ts"
export * from "./ViewTemplate.vue?vue&type=script&lang=ts"

import "./ViewTemplate.vue?vue&type=style&index=0&id=36b02571&scoped=true&lang=css"

import exportComponent from "d:\\jenkins-nodes\\Atlanta\\workspace\\Atlanta-FE-Git-189PRE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b02571"]])

export default __exports__